import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
      <i className="ri-home-4-line" />
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-600" />}
          {item.to ? (
            <Link
              to={item.to}
              className="whitespace-nowrap transition-colors hover:text-accent-400"
            >
              {item.label}
            </Link>
          ) : (
            <span className="whitespace-nowrap text-foreground-700">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}